import { createContext, useCallback, useContext, useMemo, useState } from 'react'

import { TClient } from 'services/auth/types'

import { TClientCtx } from './types'

const DEFAULT_VALUE: TClientCtx = {
  client: undefined,
  isAuthorization: true,
  setClient: () => {
    throw new Error('Not Implemented')
  },
}

const ClientContext = createContext<TClientCtx>(DEFAULT_VALUE)

export const useClientContext = () => useContext(ClientContext)

export const withClientContext = (Component: React.FC) => (props: Record<string, unknown>) => {
  const [client, setClientState] = useState<TClient | undefined>(() => {
    const stored = sessionStorage.getItem('client')
    return stored ? JSON.parse(stored) : undefined
  })
  const [isAuthorization, setIsAuthorization] = useState<boolean>(DEFAULT_VALUE.isAuthorization)

  const setClient = useCallback((clientValue: TClient | undefined) => {
    if (clientValue) {
      const isNewAccount = false

      setIsAuthorization(!isNewAccount)

      setClientState(clientValue)
      sessionStorage.setItem('client', JSON.stringify(clientValue))
    } else {
      setClientState(undefined)
      sessionStorage.removeItem('client')
    }
  }, [])

  const value = useMemo(
    () => ({ client, isAuthorization, setClient }),
    [client, isAuthorization, setClient],
  )

  return (
    <ClientContext.Provider value={value}>
      <Component {...props} />
    </ClientContext.Provider>
  )
}
